import { useEffect, useRef } from 'react';

import { Content } from 'src/contexts/ContentContext';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './CampaignModal.css';
import { INTRO_VIDEO_URL } from './CampaignModal.constants';

export const CampaignModalIntroBody = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Controls are always visible while paused; start playing after 2 seconds
    // so the user has time to see the controls and unmute before playback begins.
    const timeout = setTimeout(() => {
      video.play().catch(() => {});
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <Stack
      direction="column"
      gap="xl"
      width="full"
      alignItems="center"
      className={styles.boostBodyContainer}
    >
      <video
        ref={videoRef}
        muted
        loop
        playsInline
        controls
        className={styles.introVideo}
      >
        <source
          src={INTRO_VIDEO_URL}
          type="video/mp4"
        />
      </video>
      <span className={styles.boostSubHeaderTextSmallCentered}>
        <Content id={ContentId.HowItWorks} />
      </span>
      <Stack
        direction="column"
        gap="l"
        alignItems="center"
        width="full"
        className={styles.introStepsContainer}
      >
        <Stack gap="l" alignItems="start" width="full">
          <div className={styles.boostStepNumber}>1</div>
          <Stack direction="column">
            <span className={styles.boostStepHeader}>
              <Content id={ContentId.BoostStepOneTitle} />
            </span>
            <span className={styles.boostStepDescriptions}>
              <Content id={ContentId.BoostStepOneDescription} />
            </span>
          </Stack>
        </Stack>
        <Stack gap="l" alignItems="start" width="full">
          <div className={styles.boostStepNumber}>2</div>
          <Stack direction="column">
            <span className={styles.boostStepHeader}>
              <Content id={ContentId.BoostStepTwoTitle} />
            </span>
            <span className={styles.boostStepDescriptions}>
              <Content id={ContentId.BoostStepTwoDescription} />
            </span>
          </Stack>
        </Stack>
        <Stack gap="l" alignItems="start" width="full">
          <div className={styles.boostStepNumber}>3</div>
          <Stack direction="column">
            <span className={styles.boostStepHeader}>
              <Content id={ContentId.BoostStepThreeTitle} />
            </span>
            <span className={styles.boostStepDescriptions}>
              <Content id={ContentId.BoostStepThreeDescription} />
            </span>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
